import { NavLink, Button, Stack, Divider } from '@mantine/core';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconHome, IconUsers, IconTool, IconEye, IconBriefcase, IconMail } from '@tabler/icons-react';

interface MobileNavProps {
  onClose: () => void;
}

const links = [
  { label: 'Home', href: '/', icon: IconHome },
  { label: 'Our Story', href: '/our-story', icon: IconUsers,
    children: [
      { label: 'About Us', href: '/our-story' },
      { label: 'Engineering Expertise', href: '/our-story/engineering' },
      { label: 'Trusted Quality', href: '/our-story/quality' },
      { label: 'Superior Safety', href: '/our-story/safety' },
      { label: 'Customer Service', href: '/our-story/customer-service' },
      { label: 'Shipping Excellence', href: '/our-story/shipping' },
      { label: 'Press & Recognition', href: '/our-story/press' },
    ]
  },
  { label: 'Solutions', href: '/solutions', icon: IconTool,
    children: [
      { label: 'Our Capabilities', href: '/solutions' },
      { label: 'Industries We Serve', href: '/solutions/industries' },
      { label: 'Flat & Bent Tempered Glass', href: '/solutions/tempered-glass' },
      { label: 'Project Gallery', href: '/solutions/projects' },
      { label: 'Sporting Industry', href: '/solutions/sporting' },
      { label: 'OEM Glass Assemblies', href: '/solutions/oem' },
      { label: 'Third Party Logistics', href: '/solutions/3pl' },
      { label: 'Outsourcing & Partnerships', href: '/solutions/outsourcing' },
    ]
  },
  { label: 'In Action', href: '/in-action', icon: IconEye },
  { label: 'Join Us', href: '/join-us', icon: IconBriefcase,
    children: [
      { label: 'Careers', href: '/join-us' },
      { label: 'Benefits', href: '/join-us/benefits' },
      { label: 'Open Positions', href: '/join-us/openings' },
    ]
  },
  { label: 'Contact Us', href: '/contact', icon: IconMail,
    children: [
      { label: 'Request Quote', href: '/request-quote' },
      { label: 'Find Us', href: '/contact' },
    ]
  },
];

export default function MobileNav({ onClose }: MobileNavProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (href: string) => {
    navigate(href);
    onClose();
  };

  return (
    <Stack gap="xs">
      {links.map((link) => {
        const Icon = link.icon;
        const isActive = location.pathname === link.href ||
          (link.href !== '/' && location.pathname.startsWith(link.href));

        if (link.children) {
          return (
            <NavLink
              key={link.href}
              label={link.label}
              leftSection={<Icon size={18} />}
              active={isActive}
              variant="light"
              color="gold"
              defaultOpened={isActive}
            >
              {link.children.map((child) => (
                <NavLink
                  key={child.href}
                  label={child.label}
                  active={location.pathname === child.href}
                  variant="subtle"
                  onClick={() => handleNav(child.href)}
                />
              ))}
            </NavLink>
          );
        }

        return (
          <NavLink
            key={link.href}
            label={link.label}
            leftSection={<Icon size={18} />}
            active={isActive}
            variant="light"
            color="gold"
            onClick={() => handleNav(link.href)}
          />
        );
      })}

      <Divider my="sm" />
      <Button
        fullWidth
        color="gold"
        size="md"
        onClick={() => handleNav('/request-quote')}
      >
        Request Quote
      </Button>
    </Stack>
  );
}
